<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore.js";

const menuBarCfg = {
    cId: "menuBar",
    cType: "menuBar",
    cTitle: "menuBar Component",
    cTemplate: `<ejs-menu :items='menuItems' :select="doMenuAction" :fields="fields"><slot></slot></ejs-menu>`
};

const editorConfig = {};

const menuBarCmp = {
    name: 'menuBar',
    editorSettings: editorConfig,
    props: {
        menuItems: {
            type: Array,
            default: []
        },
        fields: {
            default: {
                itemId: "id",
                text: "text",
                parentId: "parentId",
                iconCss: "iconCss",
                url: "url",
                separator: "separator",
                children: "items"
            }
        },
        menuAction: {
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        prepareMenuItems(menuData) {
            this.menuItems = [];
            let tmpItems = [];

            if (menuData) {
                for (let i in menuData) {
                    if (i === 'length') continue;
                    let item = {
                        text: menuData[i].title,
                        value: menuData[i].name,
                        additionalParams: {
                            FF_CONSTANT: menuData[i].FF_CONSTANT,
                            action: menuData[i].action,
                            ITEM_URL: menuData[i].ITEM_URL
                        }
                    };
                    if (menuData[i].items) {
                        let subItems = [];
                        for (let j in menuData[i].items) {
                            if (j === 'length') continue;
                            let subItem = {
                                text: menuData[i].items[j].title || menuData[i].items[j].ITEM_TITLE,
                                value: menuData[i].items[j].name || menuData[i].items[j].ITEM_URL,
                                additionalParams: {
                                    FF_CONSTANT: menuData[i].items[j].FF_CONSTANT,
                                    action: menuData[i].items[j].action,
                                    ITEM_URL: menuData[i].items[j].ITEM_URL
                                }
                            };
                            if (menuData[i].items[j].items) {
                                let subSubItems = [];
                                for (let k in menuData[i].items[j].items) {
                                    if (k === 'length') continue;
                                    let tmpSubSubItem = menuData[i].items[j].items[k];
                                    tmpSubSubItem.text = tmpSubSubItem.title || tmpSubSubItem.ITEM_TITLE;
                                    tmpSubSubItem.value = tmpSubSubItem.name || tmpSubSubItem.ITEM_URL;
                                    tmpSubSubItem.additionalParams = {
                                        FF_CONSTANT: tmpSubSubItem.FF_CONSTANT,
                                        action: tmpSubSubItem.action,
                                        ITEM_URL: tmpSubSubItem.ITEM_URL
                                    };
                                    subSubItems.push(tmpSubSubItem);
                                }
                                subItem.items = subSubItems;
                            }
                            subItems.push(subItem);
                        }
                        item.items = subItems;
                    }
                    tmpItems.push(item);
                }
            }
            this.menuItems = tmpItems;
        },
        async onLoad() {
            if (this.config && this.config.menuBarSettings && this.config.menuBarSettings.isMainGrid) {
                let response = await this.sDs.post('ec_getMainGridInfo', 1, ['menu']);
                if (response && response.status === 'success' && response.data && response.data.menu) {
                    this.prepareMenuItems(response.data.menu);
                }
            }
        },
        doMenuAction(event) {
            if (typeof this.menuAction === 'function' && event && event.item && event.item.additionalParams && event.item.additionalParams.action) {
                this.menuAction(event.item.additionalParams);
            }
        }
    },
    components: {
        "ejs-menu": defineAsyncComponent(() => import('@common/syncfusion/menu'))
    }
};

componentStore.initComponent(menuBarCmp, menuBarCfg, '@common/menuBar.vue');
export { menuBarCfg, menuBarCmp };
export default menuBarCmp;
</script>

<style scoped>
:deep(.e-menu-wrapper .e-menu), :deep(.e-menu-container .e-menu) {
    background-color: white;
}
</style>
